Button = require 'components/common/button'
ConnectStore = require 'components/enhancers/connect_store'
Spinner = require 'components/common/spinner'
mediator = require 'mediator'
LaserActions = require 'actions/laser_actions'
LaserStore = require 'stores/laser_store'
Tooltip = require 'components/common/tooltip'
{ useI18n, useCoffeeCallback } = require 'lib/react_utils'
{ kebabCase } = require 'lodash'

storeConnector =
  LaserStore: (Store, props) ->
    isFetchingFromLaser: Store.isFetchingFromLaser(props.questionId)

LaserConnect = ({ questionId, questionStatus, isFetchingFromLaser }) ->

  i18n = useI18n()

  isLaserConnectEnabled = mediator.services.switches.isOn 'laserConnect'
  return null unless isLaserConnectEnabled

  <div className="laser-connect flex items-center justify-end">
    <LaserAction questionId={questionId} status={questionStatus} isFetchingFromLaser={isFetchingFromLaser}/>
  </div>


LaserAction = ({ questionId, status, isFetchingFromLaser }) ->

  currentStatus = status.getIn(['laserStatus', 'status'], '')

  i18n = useI18n()

  action = useCoffeeCallback [questionId, status], ->
    if status.get('laserStatus', Immutable.Map()).isEmpty() or status.getIn(['laserStatus', 'status']) is 'project_deleted'
      LaserActions.openCreateQuestionInLaser(questionId)
    else if status.getIn(['laserStatus', 'status']) is 'new_data_available'
      LaserActions.downloadDataFromLaser(questionId)

  return <div className="flex gap-10 items-center mr-10">
    {i18n 'laser:status.downloading'}<div className="relative"><Spinner scale={0.3} /></div>
    </div> if isFetchingFromLaser
  switch currentStatus
    when ''
      <Button shape='narrow-pill' onClick={action} label={i18n('/actions.create_in_laser')}/>
    when 'project_created', 'project_in_progress', 'data_accepted', 'data_downloaded'
      <LaserRect status={currentStatus} />
    when 'new_data_available'
      <Button shape='narrow-pill' onClick={action} label={i18n('/actions.download_from_laser')}/>
    when 'project_in_trash'
      <div className='question-progress'>
        <div className="question-progress__rects">
          <div className="question-progress__rects__rect no-bg">
            <Tooltip key={kebabCase(currentStatus)}>
              <span
                title={i18n("laser:status.#{_.str.underscored(currentStatus)}")}
                className="icon deleted-file large-icon dimmed"
              />
            </Tooltip>
          </div>
        </div>
      </div>
    when 'project_deleted'
      <span>
        <Tooltip key={kebabCase(currentStatus)}>
          <span
            title={i18n("laser:status.#{_.str.underscored(currentStatus)}")}
            className="icon deleted-file large-icon dimmed mr-5"
          />
        </Tooltip>
        <Button shape='narrow-pill' onClick={action} label={i18n('/actions.recreate_in_laser')} />
      </span>
    else
      null


LaserRect = ({ status }) ->

  i18n = useI18n("laser:status")

  <div className='question-progress'>
    <div className="question-progress__rects">
      <Tooltip key={kebabCase(status)}>
        <div
          title={i18n(_.str.underscored(status))}
          className="question-progress__rects__rect question-progress__rects__rect--#{kebabCase(status)}"
        >
          L
        </div>
      </Tooltip>
    </div>
  </div>


module.exports = ConnectStore LaserConnect, [LaserStore], storeConnector
